{
  "name": "Chromatic Scale of Harmonic Partials over A",
  "description": "12-tone 23-limit Rational Intonation (JI) scale. Derived from the harmonic partial row, it is a chromatic scale of the lowest partials that fit on a standard piano keyboard: 16°, 17°, 18°, 19°, 20°, 21°, 22°, 24°, 25°, 26°, 28°, 30° over A.",
  "scale": [
    "25/24",
    "13/12",
    "7/6",
    "5/4",
    "4/3",
    "17/12",
    "3/2",
    "19/12",
    "5/3",
    "7/4",
    "11/6",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-HS_A13-26no23",
  "built_in_group": "Marc Sabat NYKY Ensemble",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": ["E", "E", "F", "G", "G", "A", "A", "B", "C", "C", "D", "D"],
  "note_colors": [
    "#ffa0a0",
    "#fef5be",
    "#e6d7fe",
    "#ffe5e5",
    "#fffae5",
    "#ffffff",
    "#cfcfcf",
    "#ffffff",
    "#d6f7ff",
    "#fffae5",
    "#ffe5e5",
    "#dfffd6"
  ],
  "equivSteps": 12,
  "fundamental": 441,
  "reference_degree": 5,
  "center_degree": 5,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
